var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useQuery } from 'react-query';
import GLOBAL_CONFIG from '../global-variables';
import { get } from 'lodash';
import { createObjFromPath } from '../utilities/strings';
import DataSource from 'devextreme/data/data_source';
import { AuthContext } from '@michelin/central-provider';
import { useContext } from 'react';
export var API_BASE_URL = GLOBAL_CONFIG.restAPIUrl;
export var IS_TEST = GLOBAL_CONFIG.test;
export var MethodType;
(function (MethodType) {
    MethodType["GET"] = "GET";
})(MethodType || (MethodType = {}));
export var createQueryParams = function (params) {
    return Object.keys(params)
        .reduce(function (acc, k) {
        if (params[k] !== undefined) {
            acc.push(k + "=" + encodeURI(params[k]));
        }
        return acc;
    }, [])
        .join('&');
};
function getChangeHistory(api, app, authResultToken, entity, identifier, except, queryParams, ignore) {
    return __awaiter(this, void 0, void 0, function () {
        var headers, method, params, responseData, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    headers = {
                        'Authorization': "Bearer " + authResultToken
                    };
                    method = MethodType.GET;
                    params = createQueryParams(__assign(__assign({ application: app, identifier: identifier }, (except ? { except: except } : {})), queryParams));
                    return [4 /*yield*/, fetch(api + "?" + params, {
                            cache: 'no-cache',
                            headers: headers,
                            method: method,
                        })];
                case 1:
                    responseData = _a.sent();
                    return [4 /*yield*/, responseData.json()];
                case 2:
                    result = (_a.sent()) || [];
                    if (result && result.data && result.data.length) {
                        result.data.forEach(function (r) {
                            r.changes.forEach(function (change, index) {
                                var CHANGE_BEFORE = get(r.before, change, null);
                                var CHANGE_AFTER = get(r.after, change, null);
                                r.origin = createObjFromPath(r.origin || {}, change, CHANGE_BEFORE, 'origin');
                                r.diff = createObjFromPath(r.diff || {}, change, CHANGE_AFTER);
                                if (except) {
                                    delete r.origin[except];
                                    delete r.diff[except];
                                }
                            });
                        });
                    }
                    return [2 /*return*/, result];
            }
        });
    });
}
function getLastModified(api, app, entity, authResultToken, identifier, filters) {
    return __awaiter(this, void 0, void 0, function () {
        var headers, method, params, responseData, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    headers = {
                        'Authorization': "Bearer " + authResultToken
                    };
                    method = MethodType.GET;
                    params = createQueryParams(__assign({}, __assign(__assign({ application: app, entity: entity, identifier: identifier }, (filters || {})), { $limit: 1 })));
                    return [4 /*yield*/, fetch(api + "?" + params, {
                            cache: 'no-cache',
                            headers: headers,
                            method: method,
                        })];
                case 1:
                    responseData = _a.sent();
                    return [4 /*yield*/, responseData.json()];
                case 2:
                    result = (_a.sent()) || [];
                    result = result && result.data && result.data.length ? result.data[0].datetime : null;
                    return [2 /*return*/, result];
            }
        });
    });
}
function getDataSource(api, app, authResultToken, entity, identifier, except, filters, ignore) {
    var currentResults = -1;
    var updateResultsCounter = null;
    var dataSource = new DataSource({
        load: function (loadOptions) {
            return __awaiter(this, void 0, void 0, function () {
                var query, queryParams, resp;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            query = '';
                            if (loadOptions.filter) {
                                if (loadOptions.filter.filterValue) {
                                    query = loadOptions.filter.filterValue;
                                }
                                else if (loadOptions.filter.length && loadOptions.filter[0].filterValue) {
                                    query = loadOptions.filter[0].filterValue;
                                }
                            }
                            queryParams = __assign(__assign({}, (filters || {})), { $skip: loadOptions.skip || 0, $limit: loadOptions.take || 20, $query: query });
                            return [4 /*yield*/, getChangeHistory(api, app, authResultToken, entity, identifier, except, queryParams, ignore)];
                        case 1:
                            resp = _a.sent();
                            if (resp.Message)
                                throw Error(resp.Message);
                            if (resp.total === undefined)
                                return [2 /*return*/, null];
                            currentResults = resp.total;
                            if (updateResultsCounter)
                                updateResultsCounter(currentResults);
                            return [2 /*return*/, resp.data];
                    }
                });
            });
        },
        totalCount: function () {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, currentResults];
                });
            });
        },
    });
    return {
        dataSource: dataSource,
        resultsCounter: function () {
            return currentResults < 10000 ? currentResults : '10000+';
        },
    };
}
function useGetAuthTokenResult() {
    var authResult = useContext(AuthContext).authResult;
    return authResult ? authResult.accessToken : null;
}
export function useChangeLog(api, app, entity, identifier, except, filters, ignore) {
    var authResultToken = useGetAuthTokenResult();
    return getDataSource(api, app, authResultToken, entity, identifier, except, filters, ignore);
}
export function useLastModified(api, app, entity, shouldRefresh, identifier, filters) {
    var authResultToken = useGetAuthTokenResult();
    return useQuery(['ui-change-log', app, entity], function () { return getLastModified(api, app, entity, authResultToken, identifier, filters); });
}
//# sourceMappingURL=useChangelog.js.map